import { getRequestProps } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
export function PlayerBffRequestFormatter(message) {
    const { baseUrl, endpoint, method, headers, params } = getRequestProps(ConnectionNames.playerBff, message);
    headers["Content-Type"] = "application/json; charset=utf-8";
    const body = JSON.stringify(params);
    return new Request(`${baseUrl}${endpoint}`, {
        method,
        headers,
        body
    });
}
//# sourceMappingURL=PlayerBffRequestFormatter.js.map